import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'

import { AiFillCheckCircle } from 'react-icons/ai'
import { setDsrPages, updatePdsr } from '../../actions/dsr-actions'
import { redirectToNewPage } from '../../../global/helpers/global-helpers'
import PageLoader from '../../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal'



function ProspectDsrPublishModal({
  pDsrId,
  dsrPages,
  handleCloseModal,
  // Actions
  updatePdsr,
  setDsrPages,
  // Redux
  updateProspectDsrOutcome
}) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateProspectDsrOutcome) {
      const { updatePdsrStatus, sourceEvent } = updateProspectDsrOutcome || {};
      if (updatePdsrStatus && sourceEvent === "publish-prospector-dsr") {
        redirectToNewPage(`/pdsr/${pDsrId}`)
      } else if (updatePdsrStatus && sourceEvent === "re-publish-prospector-dsr") {
        redirectToNewPage(`/pdsr/${pDsrId}`)
      }
    }

  }, [updateProspectDsrOutcome, pDsrId]);

  const handleClickPublishButton = () => {
    setShowLoader(true);
    setDsrPages(dsrPages)
    updatePdsr({
      pDsrId,
      firstPublish: true, // Used to help guide backend to create instances in tables upon publishing a PDSR
      sourceEvent: "publish-prospector-dsr",
      status: 'active',
      dsrPages
    })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            Proceed with making this Prospector Room publicly available?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brand.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => handleClickPublishButton()} label='Yes, publish' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={AiFillCheckCircle} color='brand.500' boxSize="1.6em" />
        <Box color='white'>You are about to publish this Prospector Room</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePdsr,
      setDsrPages
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProspectDsrPublishModal));
